var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivingDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_67716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0V9H32.8066L34.2461 10.6562L41.5 19.0039L50.1934 9H45V0H38ZM40 2H43V11H45.8066L41.5 15.957L37.1934 11H40V2ZM0 9V45H50V12.2715L48 14.5723V37.9648L34.877 27.5898C37.1676 25.5936 38.5408 24.3972 41.3828 21.9199L40.0723 20.4141C34.9453 24.8831 29.1499 29.9336 28.3359 30.6426C26.9279 31.8686 25.534 32.002 25 32.002C24.467 32.002 23.0731 31.8696 21.6641 30.6426C20.2641 29.4236 4.123 15.3569 2 13.5059V11H31.8613L30.1172 9H0ZM2 16.1523C5.1834 18.9268 10.72 23.7507 15.1211 27.5859L2 37.9648V16.1523ZM16.6562 28.9238C17.6723 29.8092 20.1049 31.9301 20.3535 32.1465C22.2715 33.8165 24.243 33.998 25 33.998C25.759 33.998 27.7295 33.8184 29.6465 32.1484C29.9029 31.9251 32.2755 29.8587 33.3438 28.9277L48 40.5137V43H2V40.5137L16.6562 28.9238Z",
    fill: "#29CC8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_67716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivingDate);
export default __webpack_public_path__ + "static/media/ReceivingDate.30b944bf3abce9fae77c8d2cf7ca753e.svg";
export { ForwardRef as ReactComponent };